export default __webpack_public_path__ + "static/media/nft-logo.10dc8d60.svg";